export default {
    listsnap: {
        url: 'http://listsnap-api.herokuapp.com/'
    },
};